//This file is used to read, write, update and delete data. Axios makes HTTP request to fetch or save data.
import axios from 'axios';

export default class APIService {
  // get data from server
  static get(url, responseType, headers, cancelToken) {
    return axios({
      url: url,
      responseType,
      method: 'GET',
      headers,
      cancelToken
    });
  }
  // send data to server
  static post(url, postBody, responseType, cancelToken) {
    return axios({
      url: url,
      method: 'POST',
      responseType,
      data: postBody,
      cancelToken
    });
  }
  // send complete new data to update existing data
  static put(url, putBody) {
    return axios({
      url: url,
      method: 'PUT',
      data: putBody
    });
  }
  // only send data that need to change rather than sending complete data
  static patch(url, data) {
    return axios({
      url: url,
      method: 'PATCH',
      data
    });
  }
  // delete existing data from server
  static delete(url, data) {
    return axios({
      url: url,
      method: 'DELETE',
      data
    });
  }
  // all in one method which can handle read, write, update & delete
  static all(requests) {
    let arr = requests.map(request => {
      return axios[request.method](request.url, request.body);
    });
    return axios.all(arr).then(
      axios.spread((...responses) => {
        return responses;
      })
    );
  }
}
